import type { Ref } from 'vue'

export interface UseDebounce {
  displayValue: Ref<string>
  debouncedValue: Ref<string>
  debounceListener(e: Event): void
}

export default function useDebounce(timeoutCount: number = 800): UseDebounce {
  const displayValue = ref('')
  const debouncedValue = ref('')
  let timeoutRef: NodeJS.Timeout | null = null

  function debounceListener(e: Event) {
    if (timeoutRef !== null) clearTimeout(timeoutRef)

    displayValue.value = (e.target as HTMLInputElement).value
    timeoutRef = setTimeout(() => {
      debouncedValue.value = (e.target as HTMLInputElement).value
    }, timeoutCount)
  }

  return { debouncedValue, displayValue, debounceListener }
}
